export default __webpack_public_path__ + "static/media/Celebrations7.351cdc31.png";